export default (apiFetch) => async ({
  page = 1,
  size = 7,
  postType = "post",
  eventType = null,
}) => {
  let queryParams = [];

  if (size >= 0) {
    queryParams.push(`size=${size}`);
  }

  if (postType) {
    postType = postType.trim();
    queryParams.push(`post_type=${postType}`);
  }

  if (eventType) {
    eventType = eventType.trim();
    queryParams.push(`event_type=${eventType}`);
  }

  if (queryParams.length) {
    queryParams = `?${queryParams.join("&")}`;
  } else {
    queryParams = "";
  }

  const response = await apiFetch({
    endpoint: `posts/${page}/${queryParams}`,
    method: "GET",
    headers: {},
  });

  return await response.json();
};
